// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { ChartsBar } from "../../../components/Charts";

const EmployeesTotalCount: FC = () => {
  const params = new URLSearchParams(window.location.search)

  const apiParams = {
    name: "employees_total_count",
    ot: params.get('ot'),
    date_from: params.get('date_from'),
    date_to: params.get('date_to'),
    filters: {
      team: params.getAll('team[]').filter(item => item !== 'all'),
    }
  };

  return <ChartsBar
    apiParams={apiParams}
  />;
}

function StatisticsByTeamsChart1Portal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<EmployeesTotalCount/>, Root) : null;
}

export default StatisticsByTeamsChart1Portal;
